// extracted by mini-css-extract-plugin
module.exports = {"quickShop":"Mu-z","button":"Nu-z","disabled":"Ou-z"};